export default "__VITE_ASSET__DOaI9k89__"